import Vue from 'vue';
import AvatarUser from './User.vue';
import ProviderUser from './Provider.vue';

Vue.component('avatar-user', AvatarUser);
Vue.component('avatar-provider', ProviderUser);
